import AdminDataTable from "../../core/DataTable/DataTable";
import { Column } from "../../core/DataTable/DataTableInterfaces";
import { BlogsFirebaseDataTableRepository } from "./BlogsFirebaseDataTableRepository";

export function BlogsAdminList() {
    const cols:Column[] = [
        {
            name: "ID",
            field: "id",
            type: "text",
        },
        {
            name: "Title",
            field: "title",
            type: "text",
        },
        {
            name: "User",
            field: "user",
            type: "object",
            edit: false,
            has: [
                {
                    name: "Username",
                    field: "username",
                    type: "text",
                },
                {
                    name: "Email",
                    field: "email",
                    type: "text",
                },
                {
                    name: "Image",
                    field: "imageUrl",
                    type: "image",
                },
            ]
        },
        {
            name: "Description",
            field: "description",
            type: "text",
        },
        // {
        //     name: "Comments Counter",
        //     field: "commentsCounter",
        //     type: "numeric",
        //     edit: false,
        // },
        // {
        //     name: "Like Counter",
        //     field: "likeCounter",
        //     type: "numeric",
        //     edit: false,
        // },
        // {
        //     name: "Dislike Counter",
        //     field: "dislikeCounter",
        //     type: "numeric",
        //     edit: false,
        // },
        {
            name: "Markdown",
            field: "markdown",
            type: "markdown",
            show: false,
        },
        {
            name: "Images",
            field: "images",
            type: "gallery",
            show: false,
        },
        {
            name: "Categories",
            field: "categories",
            type: "hashtags",
        },
        {
            name: "Created At",
            field: "createdAt",
            type: "datetime",
            edit: false,
        },
        {
            name: "Updated At",
            field: "updatedAt",
            type: "datetime",
            edit: false,
        },
    ]
    return <AdminDataTable
        collection="blogs"
        repository={new BlogsFirebaseDataTableRepository("blogs",cols)}
        columns={cols}
    />
}